import React from "react"
import { Confirm } from "../../../../../Common/Modal/Confirm"
import { useAsyncCommand } from "../../../../../../Hooks/useAsyncCommand"
import {
    cancelable,
    JobStatus,
    jobStatusToName,
    notCancelable
} from "../../../../../../Models/API/JobModel"
import { IconCheck } from "dash-styled"
import { ReactComponent as IconClose } from "icons/lib/close-icon.svg"
import { APIJobsPerStatusModel } from "../../../../../../Models/API/APIJobsPerStatusModel"
import { LoaderModal } from "../../../../../Common/Modal/LoaderModal"

interface CancelConfirmModalProps {
    total: number
    jobsByStatus?: APIJobsPerStatusModel
    onYes: () => Promise<void>
    onNo: () => void
    isLabelByCollaborator: boolean
}

export function CancelConfirmModal({
    onNo,
    onYes,
    total,
    jobsByStatus,
    isLabelByCollaborator
}: CancelConfirmModalProps) {
    const { perform, isProcessing } = useAsyncCommand(onYes)

    if (!jobsByStatus) return <LoaderModal onClose={onNo} />

    const text = "They will not be processed."

    const description =
        total > 1 ? (
            jobsByStatus &&
            notCancelable().find(
                item =>
                    item !== JobStatus.IN_CREATION &&
                    (jobsByStatus[item] ?? 0) > 0
            ) ? (
                <>
                    <p className="text-rhino-800 mb-3">
                        {text} Data points affected:
                    </p>
                    {cancelable().map(item => {
                        if (item === JobStatus.IN_CREATION) {
                            return null
                        }
                        const entry = jobsByStatus[item]
                        return !entry ? null : (
                            <div
                                className="flex items-center mb-0.5"
                                key={item}
                            >
                                <IconCheck
                                    className="text-moss-600 mt-px mr-1"
                                    size="lg"
                                />
                                <span className="text-rhino-800">
                                    {entry}{" "}
                                    {jobStatusToName(
                                        item,
                                        isLabelByCollaborator
                                    )}
                                </span>
                            </div>
                        )
                    })}
                    {notCancelable().map(item => {
                        if (item === JobStatus.IN_CREATION) {
                            return null
                        }
                        const entry = jobsByStatus[item]
                        return !entry ? null : (
                            <div
                                className="flex items-center mb-0.5"
                                key={item}
                            >
                                <IconClose className="text-blood-700 mt-px mr-1 p-0.5 w-5 h-5" />
                                <span className="text-rhino-800">
                                    {entry}{" "}
                                    {jobStatusToName(
                                        item,
                                        isLabelByCollaborator
                                    )}
                                </span>
                            </div>
                        )
                    })}
                </>
            ) : (
                <p className="text-rhino-800">{text}</p>
            )
        ) : (
            <p className="text-rhino-800">It will not be processed.</p>
        )

    return (
        <Confirm
            title={`Cancel ${total} data point${total > 1 ? "s" : ""}?`}
            description={description}
            yesLabel={isProcessing ? "Canceling..." : "Cancel"}
            isProcessing={isProcessing}
            onClickYes={perform}
            onClose={onNo}
        />
    )
}
